'use strict';
import angular from 'angular';
import dfpHtmlUrl from './views/dfp.list.html';

var app = angular.module('app.dfpComponent', []);

app.component('dfpWidgets', {
    bindings: {
        clientId: '=',
        clusterId: '=',
        productId: '=',
        lookup: '=',
        showActions: '=',
        sets: '=',
        isEdit: '=',
        fromPage: '='
    },
    templateUrl: dfpHtmlUrl,

    // The controller that handles our component logic
    controller: function($ioAlert, ProductService, OrdersService, FormService, $scope, $element) {
        var self = this;
        self.keySelected = false;
        self.presetText = '';
        self.valuesList = [];
        self.keyValuesArray = [];
        self.showSelectKey = false;
        self.showKeyValueGroup = false;
        self.lookup_content  = [];
        self.keyValueBind = [];
        self.presetClass = '';
        self.setOfDfpValuesList = [];
        self.searchDfpValues = [];
        self.setOfValuesList = [];
        self.hasMoreValues = true;
        var DFP_VALUES_LIMIT = 40;
        self.conditionText = [
            "is",
            "is not"
        ];
        self.isDfpValuesEmpty = false;
        self.searchType = "Name";
        /*
        * handle select all values
        */
        self.selectAllValues = function(keyValueObj){
            var dfpObj = self.setOfDfpValuesList.find(function(element) { 
                return  keyValueObj.keyValue == element.key; 
            }); 
            if(dfpObj && dfpObj.values) {
                _.each(dfpObj.values, function(value) {
                    keyValueObj.values.push(value);
                })
                keyValueObj.values = _.uniqBy(keyValueObj.values, 'id');    
            }
        }

        /*
        *   Handle add new key
        */
        self.addNewKey = function(setIndex) {
            self.showSelectKey = true;
            self.sets[setIndex].push({
                keyId: null,
                keyValue: null,
                values: [],
                condition: 'is',
                searchType: "Name"
            })
        }

        /*
        * Handle add new set
        */
        self.addNewSet = function(){
            self.sets.push([]);
        }

        /*
        * Handle clear key or values elements
        */
        self.clearKey = function(setIndex, keyIndex) {
            // self.sets[setIndex][keyIndex].key = "";
            // self.sets[setIndex][keyIndex].values = [];
            self.keyValueBind.splice(keyIndex,1);
            self.sets[setIndex].splice(keyIndex, 1);
        }

        self.clearAllKeys = function(){
            self.sets = [[]];
            self.keyValueBind =[];
        }

        self.onSelectKey = function(keyValue,index){
            keyValue.searchType = "Name";
        }

        self.onSelect = function (keyValueObj, event, value, input) {
            value = value.split(',').map(val => val.trim()).join(',');
            if (!input.searchIds.$invalid && value && value !== "") {
                self.isLoadingValues = true;
                if (value.indexOf(',') > -1) {
                    var searchIds = value.split(',');
                    searchIds = _.filter(searchIds,function(el){  return el != "";})
                }
                else {
                    var searchIds = value;
                }
                OrdersService.getDfpValuesById(searchIds, self.clusterId, "DFPAudienceSegments").then(function (data) {
                    var response = OrdersService.valuesByIds;
                    if (response && response.length > 0) {
                        self.isLoadingValues = false;
                        if (!keyValueObj.keyId) {
                            var objVal = self.lookup_content.find(function (element) {
                              return keyValueObj.keyValue == element.lookup_value;
                            });
                            keyValueObj.keyId = objVal.id;
                          }
                        _.each(response, function (key) { 
                            var found = keyValueObj.values.some(el => el.id === parseInt(key.value_id))
                            if(!found){
                                keyValueObj.values.push({ id: parseInt(key.value_id), lookup_value: key.value }) 
                            }
                        });
                        keyValueObj.searchType = 'Name';
                    } else{
                        self.isLoadingValues = false;
                        $ioAlert.show('',"No Results Found", 'error');
                    }
                }, function () {
                });
            }
        }
        /*
        * load more values
        */
        self.loadMoreValues = function($event, searchKey) {
            $event.stopPropagation();
            $event.preventDefault();
            self.loading = true;
            if(self.valuesList) {
                if(searchKey.length >= 3) {
                    var loadDfpValuesObj = self.searchDfpValues.slice(self.valuesList.length, self.valuesList.length + DFP_VALUES_LIMIT);
                } else {
                    var loadDfpValuesObj = self.setOfValuesList.slice(self.valuesList.length, self.valuesList.length + DFP_VALUES_LIMIT);
                }
                self.valuesList = self.valuesList.concat(loadDfpValuesObj);
                self.hasMoreValues = loadDfpValuesObj.length === DFP_VALUES_LIMIT;
                self.loading = false;
            }
        }

        /*
        * Get all keys
        */
        self.getKeys = function() {
            if(self.fromPage == 'flight'){
                if(FormService.formFields.length>0){
                    FormService.formFields.forEach(function(product){
                        if(product.input_type == 'DFP' && product.lookup_content && product.lookup_content.length > 0){
                            product.lookup_content.forEach(function(lookups){
                                self.lookup_content.push(lookups);
                            });
                        }                    
                    });
                }
            }else{
                ProductService.getProductDfpKeys(self.clientId, self.clusterId, self.productId, self.lookup).then(function(data) {
                    data.productFields.forEach(function(product){
                        if(product.input_type == 'DFP' && product.lookup_content && product.lookup_content.length > 0){
                            product.lookup_content.forEach(function(lookups){
                                self.lookup_content.push(lookups);
                            });
                        }                    
                    });
                }, function(error) {
                        console.log("error getting keys");
                });
            }
        }

        /*
        *   load values based on search key
        */
        self.loadSearchResults = function(keyValueObj, selectObj) {
            if(selectObj.search && selectObj.search.length >= 3) {
                var obj = self.lookup_content.find(function(element) { 
                    return keyValueObj.keyValue == element.lookup_value; 
                }); 
                setTimeout(function () {
                    keyValueObj.isValuesLoaded = true;
                    OrdersService.getDfpValuesByKey(obj.id, selectObj.search, self.clusterId).then(function (data) {
                        if (OrdersService.dfpValues) {
                            if (OrdersService.dfpValues.length == 0) {
                                self.isDfpValuesEmpty = true;
                            } else {
                                self.isDfpValuesEmpty = false;
                            }
                            self.searchDfpValues = OrdersService.dfpValues;
                            self.valuesList = self.searchDfpValues.slice(0, DFP_VALUES_LIMIT);
                            self.hasMoreValues = self.valuesList.length === DFP_VALUES_LIMIT;
                            keyValueObj.isValuesLoaded = false;
                        }
                    }, function () {
                        console.log("Error getting dfp values for key ");
                    });
                }, 1000);
            } else if(selectObj.search.length < 3 || selectObj.search == ''){
                var dfpObj = self.setOfDfpValuesList.find(function(element) { 
                    return  keyValueObj.keyValue == element.key; 
                }); 
                if(dfpObj) {
                    self.setOfValuesList = dfpObj.values;
                    self.valuesList = self.setOfValuesList.slice(0, DFP_VALUES_LIMIT);
                    self.hasMoreValues = self.valuesList.length === DFP_VALUES_LIMIT;
                    keyValueObj.isValuesLoaded = false;  
                } 
            }   
        }

        /*
        *   load values based on key
        */
        self.loadKeyValues = function (val, keyValueObj, selectObj) {
            if (!self.isDfpValuesEmpty) {
                if (selectObj.search && selectObj.search.length > 0 && self.searchDfpValues && self.searchDfpValues.length > 0) {
                    self.valuesList = self.searchDfpValues.slice(0, DFP_VALUES_LIMIT);
                    self.hasMoreValues = self.valuesList.length === DFP_VALUES_LIMIT;
                if (!keyValueObj.keyId) {
                    var objVal = self.lookup_content.find(function (element) {
                        return val == element.lookup_value;
                    });
                    keyValueObj.keyId = objVal.id;
                }
                } else {
                    var dfpObj = self.setOfDfpValuesList.find(function (element) {
                        return val == element.key;
                    });
                    if (dfpObj) {
                        self.setOfValuesList = dfpObj.values;
                        keyValueObj.keyId = dfpObj.keyId;
                        self.valuesList = self.setOfValuesList.slice(0, DFP_VALUES_LIMIT);
                        self.hasMoreValues = self.valuesList.length === DFP_VALUES_LIMIT;
                    } else {
                        var obj = self.lookup_content.find(function (element) {
                            return val == element.lookup_value;
                        });
                        keyValueObj.isValuesLoaded = true;
                        if (self.keyValueBind.indexOf(val) !== -1) {

                        } else {
                            self.keyValueBind.push(val);
                        }

                        if (obj) {
                            keyValueObj.keyId = obj.id;
                            var searchKey = '';
                            OrdersService.getDfpValuesByKey(obj.id, searchKey, self.clusterId).then(function (data) {
                                if (OrdersService.dfpValues) {
                                    var dfpKeyValuesObj = {};
                                    dfpKeyValuesObj.key = val;
                                    dfpKeyValuesObj.keyId = obj.id;
                                    dfpKeyValuesObj.values = OrdersService.dfpValues;
                                    self.setOfDfpValuesList.push(dfpKeyValuesObj);
                                    self.setOfValuesList = OrdersService.dfpValues;
                                    self.valuesList = self.setOfValuesList.slice(0, DFP_VALUES_LIMIT);
                                    self.hasMoreValues = self.valuesList.length === DFP_VALUES_LIMIT;
                                    keyValueObj.isValuesLoaded = false;
                                }
                            }, function () {
                                console.log("Error getting dfp values for key ");
                            });
                        }
                    }
                }
            }
        }

        self.enableAutoFocus = function($select) {
            $select.searchInput.focus();
        }
        
        self.resetResizeWidget = function(){
                document.getElementsByClassName('widget-resize')[0].style.height =  document.getElementsByClassName('io-dfp-component')[0].style.height !=="" ? "300px" : "";
                document.getElementsByClassName('widget-resize')[0].style.width = document.getElementsByClassName('io-dfp-component')[0].style.width !=="" ? self.isEdit ? "404px" : "604px" : "";
        }


        self.initComponent = function() {
            if(self.sets && self.sets.length >0) {
                if(FormService.isValidJsonString(self.sets)){
                    self.sets = JSON.parse(self.sets);
                    for(var i=0;i<self.sets.length;i++){
                        for(var j=0;j<self.sets[i].length;j++){
                            self.keyValueBind.push(self.sets[i][j].keyValue);
                        }
                    }
                }
                if(self.showActions) {
                    self.showKeyValueGroup = true;
                    self.showSelectKey = true;
                    self.editMode = true;
                    self.presetClass = 'preset-list-edit';
                    self.getKeys();
                }else {
                    self.presetClass = 'preset-list-view';
                    self.editMode = false;
                }
            }else {
                self.sets = [
                    []
                ]
                self.editMode = true;
                self.showKeyValueGroup = true;
                self.presetClass = 'preset-list-add';
                self.getKeys();
           }
        };

        self.initComponent();
    }
});
app.directive('onEnterId', function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.onEnterId);
                });

                event.preventDefault();
            }
        });
    };
});